<template>
  <div>
    <el-form
      style="width:500px"
      ref="searchForm"
      :rules="searchRules"
      :model="searchForm"
      label-width="100px"
      size="mini"
      labelPosition="right"
    >
      <el-form-item label="评价时间" prop="timeRange">
        <el-date-picker
          style="width:400px"
          v-model="searchForm.timeRange"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          align="right"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="startSearch('searchForm')">确定</el-button>
        <el-button @click="cancleSearch">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { setTimeout } from "timers";
export default {
  data() {
    let isNumber = this.$filter.isNumber;
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      labelPosition: "left",
      searchForm: this.$store.state.currentSearchForm,
      searchRules: {
        timeRange: [
          { required: true, message: "请输入时间范围", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    nowValue() {
      return this.searchForm.timeRange;
    }
  },
  watch: {
    nowValue(i, j) {
      if (i && i.length > 0) {
        this.$emit("showSearchForm");
      } else {
        return false;
      }
    }
  },
  methods: {
    startSearch(formName) {
      if (this.$baseFunc.paramsValidate(this.searchForm)) {
        this.$message({
          type: "error",
          message: "请选择检索参数"
        });
        return false;
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = {
            searchShow: false,
            searchData: this.searchForm
          };
          this.$emit("startSearch", obj);
        } else {
          return false;
        }
      });
    },
    cancleSearch() {
      let obj = {
        searchShow: false
      };
      this.$store.state.timeSelected = false;
      this.$emit("cancleSearch", obj);
    }
  },
  created() { }
};
</script>

